import { Box, Button, TextField } from '@mui/material';
import TextFieldComponent from 'components/TextFieldComponent';
import React, { ChangeEvent } from 'react';

interface FormsProposalProps {
  generatePdf: () => void;
}

const ConfirmationPage: React.FC<FormsProposalProps> = ({ generatePdf }) => {
  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 3,
        backgroundColor: 'var(--app-surface-2)',
        width: '100%',
        height: '80%',
        boxShadow: '0 4px 24px rgba(24, 19, 19, 0.25)',
        padding: 3,
        gap: 2,
        '@media (max-width: 600px)': {
          padding: 2,
          width: '100%',
        },
      }}
    >
      <Box
        component="h2"
        sx={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#fff', mb: 2 }}
      >
        Confirmar e exportar dados
      </Box>
      <Button
        onClick={generatePdf}
        sx={{
          backgroundColor: '#1976d2',
          color: 'white',
          '&:hover': {
            backgroundColor: '#115293',
          },
        }}
        variant="contained"
      >
        Exportar PDF
      </Button>
    </Box>
  );
};

export default ConfirmationPage;
